@if (data) {
	<div [class]="getCijferClass(data)">
		{{ getCijferOfLabel(data) }}
	</div>
} @else {
	<div class="empty"></div>
}
